import {
    Component, ElementRef, HostListener,
    Input, OnInit, Renderer
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { SubMenuItem, MenuService } from '../services/menu.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'fw-submenu-item',
    template: require('./submenu-item.component.html'),
    styles: [require('./submenu-item.component.css')]
})
export class SubmenuItemComponent implements OnInit {
    private activeMenuItemSubscription: Subscription;
    @Input() subitem = <SubMenuItem>null; 

    constructor(private router: Router) {
    }

    ngOnInit(): void {

    }

    @HostListener('click', ['$event'])
    onClick(event): void {

        event.stopPropagation();
        this.router.navigate(['/' + this.subitem.route]);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/menu/submenu-item.component.ts